import React, {type ReactNode} from 'react';

import {colors} from 'js-libs/sweetcommons/styles';
import styled from 'styled-components';

import {StyledUserContentDiv} from 'app/procedures/styles';

type Props = {
  warningContent?: ReactNode;
  advancedContent?: ReactNode;
  titleContent: ReactNode;
  tagsContent?: ReactNode;
  policyContent?: ReactNode;
  descriptionContent?: ReactNode;
  extraContent?: ReactNode;
  containerClass?: string;
};
const StyledJumbotronHeader = styled.header.attrs({
  id: 'document-head',
  className: 'jumbotron px-0 mb-0',
})`
  overflow-wrap: break-word;
  background-color: ${colors.lightBg};
`;
const StyledMetaWarningDiv = styled.div`
  &:empty {
    display: none;
  }
`;

export const DocHeaderStructure = ({
  advancedContent,
  titleContent,
  descriptionContent,
  extraContent,
  containerClass = '',
  tagsContent,
  policyContent,
  warningContent,
}: Props) => {
  return (
    <StyledJumbotronHeader>
      <div className={`container ${containerClass}`}>
        {warningContent !== undefined && (
          <StyledMetaWarningDiv className="pb-4">
            {warningContent}
          </StyledMetaWarningDiv>
        )}
        {advancedContent !== undefined && <div>{advancedContent}</div>}
        {titleContent !== undefined && (
          <div className="jumbotron-heading">{titleContent}</div>
        )}
        {tagsContent !== undefined && <div>{tagsContent}</div>}
        {policyContent !== undefined && <div>{policyContent}</div>}
        {descriptionContent !== undefined && (
          <StyledUserContentDiv>{descriptionContent}</StyledUserContentDiv>
        )}
        {extraContent !== undefined && extraContent}
      </div>
    </StyledJumbotronHeader>
  );
};
